"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const DataBuilderComponentsContext = createContext(null);
DataBuilderComponentsContext.displayName = "DataBuilderComponentsContext";
function useDataBuilderComponents() {
  const components = useContext(DataBuilderComponentsContext);
  if (!components) {
    throw new Error("useDataBuilderComponents must be used within DataBuilderComponentsProvider");
  }
  return components;
}

export { DataBuilderComponentsContext, useDataBuilderComponents };
